// app/javascript/controllers/bulk_select_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "toolbar", "selectAll", "count", "idsInput"]
  static values = { param: { type: String, default: "lead_ids" }, label: { type: String, default: "selezionate" } }

  connect() {
    this.updateToolbar()
  }

  toggleAll() {
    if (!this.hasSelectAllTarget) return
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => (cb.checked = checked))
    this.updateToolbar()
  }

  toggle() {
    this.updateToolbar()
    if (!this.hasSelectAllTarget) return
    const total   = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter(cb => cb.checked).length
    this.selectAllTarget.checked       = total > 0 && checked === total
    this.selectAllTarget.indeterminate = checked > 0 && checked < total
  }

  updateToolbar() {
    const count = this.selectedIds.length
    if (this.hasToolbarTarget) {
      this.toolbarTarget.classList.toggle("hidden", count === 0)
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${count} ${this.labelValue}`
    }
  }

  // Inject selected IDs into the form before submit
  prepareForm(event) {
    const form = event.currentTarget.closest("form")
    if (!form) return

    // Remove any previously injected inputs
    form.querySelectorAll(`input[name='${this.paramValue}[]']`).forEach(el => el.remove())

    this.selectedIds.forEach(id => {
      const input   = document.createElement("input")
      input.type    = "hidden"
      input.name    = `${this.paramValue}[]`
      input.value   = id
      form.appendChild(input)
    })
  }

  get selectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }
}
